// src/store/sipSlice.ts
import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import JsSIP from "jssip";
import { storageService } from "../../services/storageService";
import apiInstance from "../../services/apiService";
import { RTCSessionEvent } from "jssip/lib/UA";
import { RootState } from "../store";

let ua: JsSIP.UA | null = null;
let calls: Record<string, any> = {}; // sessionId -> session
let currentCallId: string | null = null;
let remoteAudioElement: HTMLAudioElement | null = null;
let socketInstance: any = null;

interface Call {
  id: string;
  status: "calling" | "ringing" | "in-progress" | "ended";
  info: string;
  isMuted: boolean;
  isOnHold: boolean;
  startTime?: number;
  isGroupCall?: boolean;
   callUUID?: string;
     phoneNumber?: string;
}

interface SipState {
  registered: boolean;
  calls: Record<string, Call>;
  currentCallId: string | null;
  error: string | null;
  callerId: string | null;
}

const initialState: SipState = {
  callerId: null,
  registered: false,
  calls: {},
  currentCallId: null,
  error: null,
};

// iceServers: [
//   { urls: ["stun:167.99.187.59:3478"] },
//   { urls: ["stun:stun.l.google.com:19302"] },
// ],

const iceServers = [
  // STUN servers (no credentials)
  {
    urls: ["stun:stun.efone.app:3478", "stun:stun.l.google.com:19302"],
  },

  // TURN servers (with credentials)
  {
    urls: "turn:turn.efone.app:3478",
    username: "efone",
    credential: "SNZMVsu@C$vBNSTn",
  },
  {
    urls: "turns:turn.efone.app:5349",
    username: "efone_user",
    credential: "SNZMVsu@C$vBNSTn",
  },
];

/**
 * Initialize SIP user agent
 */
export const processedCallIds = new Set<string>();
const sessionToSocketCallId = new Map<string, string>();
let registrarServer: string = "143.198.45.154";
export const initSip = createAsyncThunk(
  "sip/init",
  async (
    {
      uri,
      password,
      server,
      registrar_server,
      authorization_user,
    }: {
      uri: string;
      password: string;
      server: string;
      registrar_server: string;
      authorization_user: string;
    },
    { dispatch ,getState}
  ) => {
    try {
      const socket = new JsSIP.WebSocketInterface(server);
      socketInstance = socket;
      registrarServer= registrar_server;
      JsSIP.debug.enable("JsSIP:*");
      const configuration = {
        sockets: [socket],
        uri,
        authorization_user,
        password,
        session_timers: false,
        // use_preloaded_route: false,
        use_preloaded_route: true, // in UA configuration
        connection_recovery_min_interval: 2,
        connection_recovery_max_interval: 30,
        pcConfig: {
          rtcpMuxPolicy: "negotiate",
          iceServers,
        },
      };

      socketInstance.onclose = () => console.warn("WebSocket closed");
      socketInstance.onopen = () => console.log("WebSocket reopened");
      socketInstance.onerror = (e: any) => console.error("WS error", e);

      ua = new JsSIP.UA(configuration);

      ua.on("connected", () => {
        dispatch(sipSlice.actions.setRegistered(true));
      });

      ua.on("disconnected", (msg) => {
        debugger;
      });

      ua.on("registered", () => {
        dispatch(sipSlice.actions.setRegistered(true));
      });

      ua.on("registrationFailed", (e: any) => {
        dispatch(sipSlice.actions.setError("Registration failed: " + e.cause));
      });

      ua.on("newRTCSession", (e: RTCSessionEvent) => {
        const session = e.session;
        const id = session.id;
        calls[id] = session;
        let resolvedReduxId: string = id;
  console.log("[SIP] newRTCSession fired, originator:", e.originator, "session:", e.session);

        // Incoming call
        if (e.originator === "remote") {
          // debugger;
          dispatch(
            sipSlice.actions.addIncomingCall({
              id,
              info: session.remote_identity.uri.toString(),
            })
          );
        }

        // Attach listeners
       session.on("ended", () => {
  const socketCallId = sessionToSocketCallId.get(id);
  const finalId = socketCallId || resolvedReduxId;
  sessionToSocketCallId.delete(id);
  delete calls[id];
  delete calls[finalId];
  dispatch(sipSlice.actions.removeCall(finalId));
  if (resolvedReduxId !== finalId) dispatch(sipSlice.actions.removeCall(resolvedReduxId)); 
  currentCallId = null;
  dispatch(sipSlice.actions.setCurrentCall(null));

 const state = (getState as () => RootState)();
  // Resume held call
  const heldEntry = Object.values(state.sip.calls).find(
    (c) => c.isOnHold && c.id !== finalId && c.id !== resolvedReduxId
  );  
  if (heldEntry) {
    const heldSession = calls[heldEntry.id];
    if (heldSession && !heldSession._end_time) {
      try {
        heldSession.unhold();
        dispatch(sipSlice.actions.setOnHold({ id: heldEntry.id, value: false }));
        dispatch(sipSlice.actions.setCurrentCall(heldEntry.id));
        dispatch(sipSlice.actions.updateCallStatus({
          id: heldEntry.id,
          status: "in-progress",
          info: heldSession.remote_identity.uri.toString(),
        }));
        currentCallId = heldEntry.id;
      } catch (err) {
        console.error("Failed to resume held call:", err);
      }
    }
  }
});

  session.on("failed", () => {
  const socketCallId = sessionToSocketCallId.get(id);
  const finalId = socketCallId || resolvedReduxId;
  sessionToSocketCallId.delete(id);
  delete calls[id];
  delete calls[finalId];
  dispatch(sipSlice.actions.removeCall(finalId));
  if (resolvedReduxId !== finalId) dispatch(sipSlice.actions.removeCall(resolvedReduxId)); // 🔑 only if different
  currentCallId = null;
  dispatch(sipSlice.actions.setCurrentCall(null));
});

        session.on("confirmed", () => {
          const socketCallId = sessionToSocketCallId.get(id);
          if (socketCallId) 
            {
               calls[socketCallId] = session;
                delete calls[id];
                 sessionToSocketCallId.delete(id);
                 resolvedReduxId = socketCallId;
                  currentCallId = socketCallId;
        }
        else {
      resolvedReduxId = id;
      currentCallId = id;
        }
        dispatch(sipSlice.actions.updateCallStatus({
          id:resolvedReduxId,
          status: "in-progress",
          info: session.remote_identity.uri.toString(),
          startTime: session.start_time ? session.start_time.getTime() : Date.now(),
        }));
        dispatch(sipSlice.actions.setCurrentCall(resolvedReduxId));

});
          

        session.connection?.addEventListener("track", (e: any) => {
          if (e.streams && e.streams[0]) {
            remoteAudioElement = new Audio();
            remoteAudioElement.srcObject = e.streams[0];
            remoteAudioElement.autoplay = true;
            remoteAudioElement
              .play()
              .catch((err) => console.error("Audio play failed:", err));
          }
        });
      });

      ua.start();
    } catch (err: any) {
      dispatch(sipSlice.actions.setError(err.message));
    }
  }
);

/**
 * Make a new SIP call
 */
export const makeCall = createAsyncThunk(
  "sip/makeCall",
  async (
    {
      source,
      target,
      callType,
    }: { source: string; target: string; callType: string },
    { dispatch }
  ) => {
    // debugger;
    if (!ua) {
      dispatch(sipSlice.actions.setError("UA not initialized"));
      return;
    }

    const extraHeaders = [
      `X-callType: ${callType}`,
      `X-sourceNumber: ${source}`,
    ];

    const options = {
      extraHeaders,
      mediaConstraints: { audio: true, video: false },
      connection_recovery_min_interval: 2,
      connection_recovery_max_interval: 30,
      pcConfig: {
        iceServers,
      },
    };

    const session = ua.call(target, options);
    const id = session.id;
    // calls[id] = session;

    dispatch(
      sipSlice.actions.addOutgoingCall({
        id,
        info: target,
      })
    );

    currentCallId = id;
    dispatch(sipSlice.actions.setCurrentCall(id));
  }
);

/**
 * Make a new SIP Group call
 */
export const makeGroupCall = createAsyncThunk(
  "sip/makeGroupCall",
  async (
    {
      source,
      callType,
      groupId,
      memberIds,
      isJoining = false,
    }: {
      source?: string;
      callType?: string;
      groupId: string;
      memberIds?: string;
      isJoining?: boolean;
    },
    { dispatch }
  ) => {
    if (!ua) {
      dispatch(sipSlice.actions.setError("UA not initialized"));
      return;
    }

    let extraHeaders = [];
    if (isJoining) {
      const uuid = `randomId-${groupId}`;
      extraHeaders = [`X-callUUID: ${uuid}`, `X-groupId: ${groupId}`];
    } else {
      extraHeaders = [
        `X-callType: ${callType}`,
        `X-sourceNumber: ${source}`,
        `X-groupId: ${groupId}`,
        `X-memberIds: ${memberIds}`,
      ];
    }

    const options = {
      extraHeaders,
      mediaConstraints: { audio: true, video: false },
      pcConfig: {
        iceServers,
      },
    };

    const session = ua.call(groupId, options);
    const id = session.id;
    calls[id] = session;

    dispatch(
      sipSlice.actions.addOutgoingCall({
        id,
        info: session.remote_identity.uri.toString(),
        isGroupCall: true,
      })
    );

    currentCallId = id;
    dispatch(sipSlice.actions.setCurrentCall(id));
  }
);

/**
 * Accept incoming call
 */
export const acceptCall = createAsyncThunk(
  "sip/acceptCall",
 async (
    { callId, sourceNumber, actionType }:
    { callId: string; sourceNumber: string; actionType?: string },
    { dispatch, getState }
  ) => {
    const state = getState() as any;
    const callInfo = state.sip.calls[callId];
    const session = calls[callId];  
    if (!session) {
      if (!ua) {
        dispatch(sipSlice.actions.setError("UA not initialized"));
        return;
      }
      const callUUID = callInfo?.callUUID || storageService.getUdid();
      const extraHeaders = [
        `X-sourceNumber: ${sourceNumber}`,
        `X-callType: 1`,
        `X-callUUID: ${callUUID}`,
        `X-callId: ${callId}`,
      ];

      const options = {
        extraHeaders,
        mediaConstraints: { audio: true, video: false },
        pcConfig: { iceServers },
      };
      const phoneNumber = callInfo?.phoneNumber;
      const targetUri = `sip:${phoneNumber}@${registrarServer}`;
      console.log("[SIP] Accepting socket call, calling back:", targetUri);

      const newSession = ua.call(targetUri, options);
      const id = newSession.id;
      calls[id] = newSession;
      sessionToSocketCallId.set(id, callId);
      // currentCallId = id;
      // dispatch(sipSlice.actions.removeCall(callId)); 
      // dispatch(sipSlice.actions.addOutgoingCall({ id, info: targetUri }));
    
      // dispatch(sipSlice.actions.setCurrentCall(id));
return;
    };
    // debugger;

    // this logic handles holdAndAccept and endAndAccept actions
    if (currentCallId && currentCallId !== callId) {
      const activeSession = calls[currentCallId];

      if (actionType === "holdAndAccept") {
        // debugger;
        if (activeSession && activeSession?.status === 9) {
          try {
            activeSession.hold();
            dispatch(
              sipSlice.actions.setOnHold({ id: currentCallId, value: true })
            );
          } catch (err) {
            console.error("Failed to hold current call:", err);
          }
        }
      } else if (actionType === "endAndAccept") {
        // debugger;
        if (activeSession && activeSession?.status === 9) {
          try {
            activeSession.terminate();
            dispatch(
              sipSlice.actions.updateCallStatus({
                status: "ended",
                id: currentCallId,
                info: "",
              })
            );
          } catch (err) {
            console.error("Failed to end current call:", err);
          }
        }
      }
    }

    const udid = storageService.getUdid();
    const extraHeaders = [
      `X-sourceNumber: ${sourceNumber}`,
      "X-callType: 1",
      `X-callUUID: ${udid}`,
    ];

    session.answer({
      extraHeaders,
      mediaConstraints: { audio: true, video: false },
      pcConfig: {
        iceServers,
      },
    });

    session.connection?.addEventListener("track", (e: any) => {
      if (e.streams && e.streams[0]) {
        remoteAudioElement = new Audio();
        remoteAudioElement.srcObject = e.streams[0];
        remoteAudioElement.autoplay = true;
        remoteAudioElement
          .play()
          .catch((err) => console.error("Audio play failed:", err));
      }
    });

    dispatch(
      sipSlice.actions.updateCallStatus({
        id: callId,
        status: "in-progress",
        info: session.remote_identity.uri.toString(),
      })
    );

    currentCallId = callId;
    dispatch(sipSlice.actions.setCurrentCall(callId));
  }
);

export const acceptGroupCall = createAsyncThunk(
  "sip/acceptGroupCall",
  async (
    {
      groupId,
      uuid,
    }: {
      groupId: string;
      uuid: string;
    },
    { dispatch }
  ) => {
    if (!ua) {
      dispatch(sipSlice.actions.setError("UA not initialized"));
      return;
    }

    const extraHeaders = [
      `X-callType: 1`,
      `X-groupId: ${groupId}`,
      `X-callUUID: ${uuid}`,
    ];

    const options = {
      extraHeaders,
      mediaConstraints: { audio: true, video: false },
      pcConfig: {
        iceServers,
      },
    };

    const session = ua.call(groupId, options);
    const id = session.id;
    calls[id] = session;

    dispatch(
      sipSlice.actions.addIncomingCall({
        id,
        info: session.remote_identity.uri.toString(),
        isGroupCall: true,
      })
    );

    currentCallId = id;
    dispatch(sipSlice.actions.setCurrentCall(id));
  }
);

/**
 * Reject incoming call
 */
export const rejectCall = createAsyncThunk(
  "sip/rejectCall",
  async (callId: string, { dispatch }) => {
    const session = calls[callId];
    if (!session) 
      {
      dispatch(sipSlice.actions.removeCall(callId))
      return;
    }
    session.terminate({ status_code: 486, reason_phrase: "Busy Here" });
    delete calls[callId];
    dispatch(sipSlice.actions.removeCall(callId));
  }
);

/**
 * Reject incoming group call
 */
export const rejectGroupCall = createAsyncThunk(
  "sip/rejectGroupCall",
  async (
    {
      sourceNumber,
      uuid,
      groupId,
      groupName,
      callerName,
      callerId,
    }: {
      sourceNumber: string;
      uuid: string;
      groupId: string;
      groupName: string;
      callerName: string;
      callerId: string;
    },
    { dispatch }
  ) => {
    if (!ua) {
      dispatch(sipSlice.actions.setError("UA not initialized"));
      return;
    }

    const extraHeaders = [
      `X-sourceNumber: ${sourceNumber}`,
      `X-callType: 1`,
      `X-user_action: USER_BUSY`,
      `X-callUUID: ${uuid}`,
      `X-groupId: ${groupId}`,
      `X-groupName: ${groupName}`,
      `X-groupCallInitFullName: ${callerName}`,
      `X-groupCallInitUserId: ${callerId}`,
    ];

    const options = {
      extraHeaders,
      mediaConstraints: { audio: true, video: false },
      pcConfig: {
        iceServers,
      },
    };

    ua.call(groupId, options);
  }
);

/**
 * Hang up active call
 */
export const hangup = createAsyncThunk(
  "sip/hangup",
  async (callId: string, { dispatch }) => {
    // currentCallId = callId;
    const session = calls[callId];
    if (session) {
   try { session.terminate(); } catch {}
      delete calls[callId];
    }
        if (currentCallId === callId) currentCallId = null;

    dispatch(sipSlice.actions.removeCall(callId));
        dispatch(sipSlice.actions.setCurrentCall(null));

  }
);

/**
 * Hold call
 */
export const holdCall = createAsyncThunk(
  "sip/holdCall",
  async (callId: string, { dispatch }) => {
    const session = calls[callId];
    if (session) {
      session.hold();
      dispatch(sipSlice.actions.setOnHold({ id: callId, value: true }));
    }
  }
);

/**
 * Resume call
 */
export const resumeCall = createAsyncThunk(
  "sip/resumeCall",
  async (callId: string, { dispatch }) => {
    currentCallId = callId;
    const session = calls[callId];
    if (session) {
      session.unhold();
      dispatch(sipSlice.actions.setOnHold({ id: callId, value: false }));
    }
  }
);

/**
 * Mute call
 */
export const muteCall = createAsyncThunk(
  "sip/muteCall",
  async (callId: string, { dispatch }) => {
    currentCallId = callId;
    const session = calls[callId];
    if (session) {
      session.mute({ audio: true });
      dispatch(sipSlice.actions.setMuted({ id: callId, value: true }));
    }
  }
);

/**
 * Unmute call
 */
export const unmuteCall = createAsyncThunk(
  "sip/unmuteCall",
  async (callId: string, { dispatch }) => {
    currentCallId = callId;
    const session = calls[callId];
    if (session) {
      session.unmute({ audio: true });
      dispatch(sipSlice.actions.setMuted({ id: callId, value: false }));
    }
  }
);

/**
 * Send DTMF
 */
export const sendDTMF = createAsyncThunk(
  "sip/sendDTMF",
  async ({ callId, tone }: { callId: string; tone: string }, { dispatch }) => {
    const session = calls[callId];
    if (session) {
      try {
        const dtmfMode = storageService.getDtmfMode();
        if (dtmfMode === "inBand") {
          session.sendDTMF(tone, { dtmfType: "info" });
        } else {
          session.sendDTMF(tone);
        }
      } catch (err) {
        console.error("Failed to send DTMF:", err);
        dispatch(sipSlice.actions.setError("Failed to send DTMF"));
      }
    }
  }
);

/**
 * Switch output (speaker) device for current call
 */
export const switchSpeakerDevice = createAsyncThunk(
  "sip/switchSpeakerDevice",
  async (deviceId: string, { dispatch }) => {
    try {
      const audioEl = remoteAudioElement as HTMLAudioElement & {
        setSinkId?: (sinkId: string) => Promise<void>;
      };

      if (audioEl && typeof audioEl.setSinkId === "function") {
        await audioEl.setSinkId(deviceId);
      } else {
        console.warn("Browser does not support audio output switching.");
      }
    } catch (error) {
      console.error("Failed to set output device:", error);
      dispatch(sipSlice.actions.setError("Failed to set output device"));
    }
  }
);

const sipSlice = createSlice({
  name: "sip",
  initialState,
  reducers: {
    setCallerId(state, action: PayloadAction<any>) {
      state.callerId = action.payload || state.callerId;
    },
    setRegistered(state, action: PayloadAction<boolean>) {
      state.registered = action.payload;
    },
    addIncomingCall(
      state,
  action: PayloadAction<{ id: string; info: string; isGroupCall?: boolean; callUUID?: string; phoneNumber?: string }>
    ) {
      state.calls[action.payload.id] = {
    id: action.payload.id,
    status: "ringing",
    info: action.payload.info,
    isMuted: false,
    isOnHold: false,
    callUUID: action.payload.callUUID,
    phoneNumber: action.payload.phoneNumber,
    ...(action.payload.isGroupCall !== undefined && {
      isGroupCall: action.payload.isGroupCall,
    }),
  };
    },
    addOutgoingCall(
      state,
      action: PayloadAction<{ id: string; info: string; isGroupCall?: boolean }>
    ) {
      state.calls[action.payload.id] = {
        id: action.payload.id,
        status: "calling",
        info: action.payload.info,
        isMuted: false,
        isOnHold: false,
        ...(action.payload.isGroupCall !== undefined && {
          isGroupCall: action.payload.isGroupCall,
        }),
      };
    },
    updateCallStatus(
      state,
      action: PayloadAction<{
        id: string;
        status: string;
        info: string;
        startTime?: number;
      }>
    ) {
      if (state.calls[action.payload.id]) {
        state.calls[action.payload.id].status = action.payload
          .status as Call["status"];
        state.calls[action.payload.id].info = action.payload.info;

        if (action.payload.startTime) {
          state.calls[action.payload.id].startTime = action.payload.startTime;
        }
      }
    },
    removeCall(state, action: PayloadAction<string>) {
      delete state.calls[action.payload];
    },
    setCurrentCall(state, action: PayloadAction<string | null>) {
      state.currentCallId = action.payload;
    },
    setMuted(state, action: PayloadAction<{ id: string; value: boolean }>) {
      if (state.calls[action.payload.id]) {
        state.calls[action.payload.id].isMuted = action.payload.value;
      }
    },
    setOnHold(state, action: PayloadAction<{ id: string; value: boolean }>) {
      if (state.calls[action.payload.id]) {
        state.calls[action.payload.id].isOnHold = action.payload.value;
      }
    },
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },
  },
});

export const acceptSocketCall = createAsyncThunk(
  "sip/acceptSocketCall",
  async (
    { callId, callUUID, sourceNumber }: 
    { callId: string; callUUID: string; sourceNumber: string },
    { dispatch }
  ) => {
    try {
      const udid = storageService.getUdid();
      await apiInstance.post("/calls/accept", {
        callId,
        callUUID,
        sourceNumber,
        udid,
      });
      dispatch(sipSlice.actions.updateCallStatus({
        id: callId,
        status: "in-progress",
        info: sourceNumber,
      }));
      dispatch(sipSlice.actions.setCurrentCall(callId));
    } catch (err) {
      console.error("Failed to accept call:", err);
    }
  }
);

export const rejectSocketCall = createAsyncThunk(
  "sip/rejectSocketCall",
  async (
    { callId, callUUID }: { callId: string; callUUID: string },
    { dispatch }
  ) => {
    try {
      await apiInstance.post("/calls/reject", { callId, callUUID });
      dispatch(sipSlice.actions.removeCall(callId));
    } catch (err) {
      console.error("Failed to reject call:", err);
    }
  }
);

export const {
  setCallerId,
  setRegistered,
  addIncomingCall,
  updateCallStatus,
  removeCall,
  setCurrentCall,
  setMuted,
  setOnHold,
  setError,
} = sipSlice.actions;

export const selectHasActiveCall = (state: RootState): boolean =>
  Object.values(state.sip.calls).some(
    (call) => call.status === "calling" || call.status === "ringing" || call.status === "in-progress"
  );

export default sipSlice.reducer;
